import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import searchIcon from "./../../media/search-icon.svg";
import { API_URL } from "../../AuthContext";
import Logger from "../../utils/Logger";
import { LoadingComponent } from "../../App.js";
import httpClient from "../../services/httpClient.js";

const DHLParcel = () => {
  const { t } = useTranslation();
  const [zipcode, setZipcode] = useState("");
  const [searchedZipcode, setSearchedZipcode] = useState(""); // New state for searched zipcode
  const [serviceInfo, setServiceInfo] = useState(null); // Changed to null initially
  const [error, setError] = useState(null);
  const [parcels, setParcels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingParcels, setLoadingParcels] = useState(false);
  const [hasSearched, setHasSearched] = useState(false); // Track if user has searched

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!/^[0-9]{2}-?[0-9]{3}$/.test(zipcode)) {
      setError(t("logistics.invalidPostalCode"));
      setServiceInfo(null);
      setHasSearched(false);
      return;
    }

    setLoadingParcels(true);
    setError(null);
    setServiceInfo(null);
    setHasSearched(true);
    setSearchedZipcode(zipcode); // Store the searched zipcode

    try {
      const response = await httpClient.get(`Dhl/postal-code/${zipcode}`, {
        withAuth: true,
      });

      const responseData = response.data;

      const {
        deliveryAt9,
        deliveryAt12,
        deliveryBetween18And22,
        deliveryOnSaturday,
      } = responseData;

      setServiceInfo({
        deliveryAt9:
          deliveryAt9 === true || deliveryAt9 === "true"
            ? t("common.yes")
            : t("common.no"),
        deliveryAt12:
          deliveryAt12 === true || deliveryAt12 === "true"
            ? t("common.yes")
            : t("common.no"),
        deliveryBetween18And22:
          deliveryBetween18And22 === true || deliveryBetween18And22 === "true"
            ? t("common.yes")
            : t("common.no"),
        deliveryOnSaturday:
          deliveryOnSaturday === true || deliveryOnSaturday === "true"
            ? t("common.yes")
            : t("common.no"),
      });

      setError(null);
    } catch (error) {
      console.error("Błąd podczas wysyłania zapytania:", error);
      setError(t("logistics.errorCheckingServices"));
      setServiceInfo(null);
    } finally {
      setLoadingParcels(false);
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetch(`${API_URL}/dhl-parcels`);
  //       if (!response.ok) {
  //         Logger.error("Fetch error:", response.status, response.statusText);
  //         return;
  //       }
  //       const data = await response.json();
  //       setParcels(data);
  //     } catch (error) {
  //       Logger.error("Błąd podczas wysyłania zapytania:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, []);

  return (
    <div className="dhl-service-checker">
      <h1>{t("logistics.dhlParcel")}</h1>

      {loading ? (
        <div className="loading-spinner">Ładowanie usług DHL...</div>
      ) : (
        <>
          <form className="formularz" onSubmit={handleSubmit}>
            <label htmlFor="zipcode">
              <div className="input-container">
                <input
                  type="text"
                  name="zipcode"
                  id="zipcode"
                  placeholder={t("logistics.postalCode")}
                  value={zipcode}
                  onChange={(e) => setZipcode(e.target.value)}
                />
                <img
                  src={searchIcon}
                  alt="search Icon"
                  className="search-icon"
                  onClick={handleSubmit}
                />
              </div>
            </label>
            <div className="check">
              <input
                type="submit"
                value={
                  loadingParcels
                    ? t("logistics.checking")
                    : t("logistics.check")
                }
                disabled={loadingParcels}
              />
            </div>
          </form>

          {error && <div className="error">{error}</div>}

          {loadingParcels && hasSearched && <LoadingComponent />}

          {serviceInfo && !loadingParcels && (
            <div className="service-info">
              <h2>
                {t("logistics.possibleDeliveries")} <b>{searchedZipcode}</b>:
              </h2>
              <p>
                <b>{t("logistics.delivery9")}</b>{" "}
                <span
                  className={
                    serviceInfo.deliveryAt9 === t("common.yes")
                      ? "green"
                      : "red"
                  }
                >
                  {serviceInfo.deliveryAt9}
                </span>
              </p>
              <p>
                <b>{t("logistics.delivery12")}</b>{" "}
                <span
                  className={
                    serviceInfo.deliveryAt12 === t("common.yes")
                      ? "green"
                      : "red"
                  }
                >
                  {serviceInfo.deliveryAt12}
                </span>
              </p>
              <p>
                <b>{t("logistics.delivery18_22")}</b>{" "}
                <span
                  className={
                    serviceInfo.deliveryBetween18And22 === t("common.yes")
                      ? "green"
                      : "red"
                  }
                >
                  {serviceInfo.deliveryBetween18And22}
                </span>
              </p>
              <p>
                <b>{t("logistics.deliverySaturday")}</b>{" "}
                <span
                  className={
                    serviceInfo.deliveryOnSaturday === t("common.yes")
                      ? "green"
                      : "red"
                  }
                >
                  {serviceInfo.deliveryOnSaturday}
                </span>
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DHLParcel;
